import React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { SupporterVoicesComments } from './components/SupporterVoicesComments';
import { SupporterVoicesFeed } from './components/SupporterVoicesFeed';
import { SupporterVoicesVideos } from './components/SupporterVoicesVideos';
import { useSupporterVoicesSection } from './hooks/useSupporterVoicesSection';

type Props = {
	showSupporterVoicesFeed: boolean;
};

export const SupporterVoices: React.FC<Props> = ({ showSupporterVoicesFeed }) => {
	const {
		data: { showSupporterVoicesSection },
	} = useSupporterVoicesSection();

	if (!showSupporterVoicesSection) {
		return <div className="hidden" data-testid="petition-page-supporters-voices-hidden" />;
	}

	// Only swap in the mixed feed when the FCM is enabled AND there are enough items
	// to fill it. Thin petitions (fewer than the minimum) stay on the legacy sections.
	if (showSupporterVoicesFeed) {
		return (
			<div data-testid="petition-page-supporters-voices">
				<ClientRender>
					<SupporterVoicesFeed />
				</ClientRender>
			</div>
		);
	}

	return (
		<div data-testid="petition-page-supporters-voices" className="flex flex-col gap-6">
			<ClientRender>
				<SupporterVoicesComments />
				<SupporterVoicesVideos />
			</ClientRender>
		</div>
	);
};
